// Études et devis › Catalogue technique (31/10/2026) : ce que la Proposition TRAME lit de l'entreprise, enfin saisissable à l'écran.
// Trois onglets : matériels de la gamme, tables de la notice du fabricant, réglages de la proposition. Les règles de charge
// (notices, fluides) s'ouvrent dans leur fenêtre habituelle. Droits : ceux de l'API (lire = dossier.lire ; saisir =
// conception.ecrire ; valider = echelle.valider) ; un écran n'élargit jamais un droit.
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { Scale } from 'lucide-react';
import { useSession } from '../../../lib/session.tsx';
import { Alerte, Bouton, EntetePage, EtatVide, FilContexte, Onglets } from '../../../components/ui.tsx';
import { ReglesCharge } from '../NoticesCharge.tsx';
import { OngletModeles } from './OngletModeles.tsx';
import { OngletTablesNotice } from './OngletTablesNotice.tsx';
import { OngletReglages } from './OngletReglages.tsx';
import '../../../styles/catalogue-technique.css';

type Onglet = 'materiels' | 'tables' | 'reglages';
const ONGLETS: { id: Onglet; libelle: string }[] = [{ id: 'materiels', libelle: 'Matériels' }, { id: 'tables', libelle: 'Tables de la notice' }, { id: 'reglages', libelle: 'Réglages de la proposition' }];

export function PageCatalogueTechnique() {
  const { peut } = useSession();
  const [params, setParams] = useSearchParams();
  const onglet = (ONGLETS.some((o) => o.id === params.get('onglet')) ? params.get('onglet') : 'materiels') as Onglet;
  const [regles, setRegles] = useState(false);
  const changer = (o: Onglet) => setParams((p) => { const n = new URLSearchParams(p); n.set('onglet', o); if (o !== 'tables') n.delete('notice'); return n; }, { replace: true });

  if (!peut('dossier.lire')) return <EtatVide titre="Accès réservé" texte="Votre rôle ne permet pas de consulter le catalogue technique." />;
  return <div className="pile ctech-page">
    <EntetePage fil={<FilContexte noeuds={[{ type: '', libelle: 'Études et devis', to: '/etudes' }, { type: '', libelle: 'Catalogue technique' }]} />}
      titre="Catalogue technique et réglages"
      sousTitre="Ce que la Proposition TRAME lit de votre entreprise : matériels de la gamme, tables de la notice du fabricant, réglages. Aucune valeur de fabricant n’est fournie : chaque valeur se recopie depuis la notice, avec sa source, puis le référent la valide."
      actions={<Bouton icone={<Scale aria-hidden />} onClick={() => setRegles(true)}>Règles de charge</Bouton>} />
    {!peut('catalogue.ecrire') && <Alerte titre="Lecture seule">Votre rôle consulte le catalogue et les réglages sans les modifier.</Alerte>}
    <Onglets libelle="Catalogue technique" onglets={ONGLETS} actif={onglet} changer={changer} />
    {onglet === 'materiels' && <OngletModeles />}
    {onglet === 'tables' && <OngletTablesNotice noticeInitiale={params.get('notice')} ouvrirRegles={() => setRegles(true)} />}
    {onglet === 'reglages' && <OngletReglages />}
    <ReglesCharge ouvert={regles} fermer={() => setRegles(false)} />
  </div>;
}
